import React from 'react';
import '../blogs.module.css'
import OriginalComment from './OriginalComment';

const Comments = ({comments,refetch}) => {


    return(
        comments.filter(comment => comment.parentComment === null).map(comment =>
        <OriginalComment
            comment={comment} refetch={refetch}
        />)
    )
}

export default Comments;


// WEBPACK FOOTER //
// ./src/components/Blogs/Comments/index.js